// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_price.scss
// module id = 48
// module chunks = 0